import $ from 'jquery'

import util from '../util'

const Element = function (data) {
    this.id = data.id;
    this.page = data.page;

    this.left = data.left;
    this.top = data.top;
    this.right = data.left + data.width;
    this.bottom = data.top + data.height;

    this.type = data.type;
    this.width = data.width;
    this.height = data.height;

    this.hmid = data.left + data.width / 2;
    this.vmid = data.top + data.height / 2;

    this.active = true
};

let elements = [];

const getElements = function () {
    return elements;
};

const remove = function (id) {
    elements = elements.filter((element) => element.id !== id);
};

const getById = function (id) {
    let i;
    const { length } = elements;

    for (i = 0; i < length; i++) {
        const image = elements[i];
        if (image.id === id) {
            return image;
        }
    }

    return null;
};

const update = function (id, props) {
    const element = getById(id);
    if (element) {
        for (const key of Object.keys(props)) {
            element[key] = props[key];
        }
        element.right = element.left + element.width;
        element.bottom = element.top + element.height;
        element.hmid = element.left + element.width / 2;
        element.vmid = element.top + element.height / 2;
    }
};

const add = function (data) {
    elements.push(new Element(data));
};

const clear = function (pageId) {
    if (pageId) {
        elements = elements.filter((element) => element.page !== pageId);
    } else {
        elements = [];
    }
};

const refresh = function () {
    elements.forEach((element) => {
        const $element = $(`#${element.id}`);
        element.left = parseFloat($element.css('left'));
        element.top = parseFloat($element.css('top'));
        element.width = $element.width();
        element.height = $element.height();
        element.right = element.left + element.width;
        element.bottom = element.top + element.height;
        element.active = element.width > 0 && element.height > 0;

        element.hmid = element.left + element.width / 2;
        element.vmid = element.top + element.height / 2;
    });
};

const getImageByPos = function (page, top, left) {
    let found = null;
    let i;
    const { length } = elements;

    for (i = 0; i < length; i++) {
        const element = elements[i];
        if (element.page === page
            && element.type === 'image'
            && (element.left < left && left < element.right)
            && (element.top < top && top < element.bottom)
        ) {
            found = element;
        }
    }

    return found;
};

const addToMatrix = function ($element, type) {
    const $page = $element.parents('.page');
    const width = $element.width();
    const height = $element.height();

    if (width === 0 || height === 0) return;

    const left = parseFloat($element.css('left'));
    const top = parseFloat($element.css('top'));

    add({
        id: $element.attr('id'),
        type,
        page: $page.attr('id'),
        left,
        top,
        width,
        height: type === 'image' ? parseInt($element.css('height'), 10) : height
    })
};

const init = function () {
    $('.move').each(function () {
        const $this = $(this);
        if (util.isImage($this)) {
            if ($this.find('img').prop('complete')) {
                addToMatrix($this, 'image');
            } else {
                $this.find('img').on('load', () => {
                    addToMatrix($this, 'image');
                });
            }
        } else if (util.isFrame($this)) {
            addToMatrix($this, 'image');
        } else  {
            addToMatrix($this, 'text');
        }
    })
};

const toString = function () {
    let text = '';
    elements.forEach((element) => {
        text += `{ type: ${element.type}, page: ${element.page}, id: ${element.id}, top: ${element.top}, right: ${element.right}, bottom: ${element.bottom}, left: ${element.left}}\n`;
    });
    return text;
};

const show = function () {
    getElements().forEach((element) => {
        $(`#${element.page}`).append(`
            <div class='matrix-debugger' style="
                position: absolute;
                z-index: 10;
                background: rgba(0,0,0,.75);
                width: ${element.width}px;
                height: ${element.height}px;
                top: ${element.top}px;
                left: ${element.left}px
            ">
            </div>
        `);
    });
};

const hide = function () {
    $('.matrix-debugger').remove();
};

window.D = window.D || {};
window.D.showCanvasMatrix = show;
window.D.hideCanvasMatrix = hide;
window.D.printCanvasMatrix = () => console.log(toString());

export default {
    init,
    add,
    update,
    remove,
    refresh,
    toString,
    clear,

    getElements,

    getById,
    getImageByPos
}
